<template>
  <div>
    <h1>
      新增导入
      <a-button
        class="top_btn"
        style="margin-left: 15px;"
        type="primary"
        @click="importProduct()"
      >
        产品导入</a-button
      >
    </h1>
    <h1>
      <a-link style="cursor: pointer;" type="primary" @click="getList()"
        >导入日志</a-link
      >
    </h1>
    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      rowKey="id"
      :scroll="{ x: 1000 }"
    >
      <span slot="status" slot-scope="text, record"
        >{{ record.status_text }}
      </span>
      <span slot="action" slot-scope="text">
        <a class="red" v-if="text.status == 2" @click="delLog(text.id)">删除</a>
        <a v-else disabled>删除</a>
      </span>
    </a-table>
    <ProductImportModal
      ref="proImportModal"
      @refresh="getList()"
      :seachData="seachData"
    ></ProductImportModal>
  </div>
</template>

<script>
import API from "../api";
import { debounce, validator } from "@/utils/utils";
import ProductImportModal from "./productImportModal";

const columns = [
  {
    title: "导入内容",
    dataIndex: "detail_url",
    ellipsis: true,
    key: "detail_url",
    width: "500px"
  },
  {
    title: "导入平台",
    dataIndex: "platform_type_text",
    ellipsis: true,
    key: "platform_type_text",
    width: "100px"
  },
  {
    title: "提交时间",
    dataIndex: "commit_time",
    ellipsis: true,
    key: "commit_time",
    scopedSlots: { customRender: "commit_time" },
    width: "150px"
  },
  {
    title: "导入完成时间",
    dataIndex: "finish_time",
    ellipsis: true,
    key: "finish_time",
    scopedSlots: { customRender: "finish_time" },
    width: "150px"
  },
  {
    title: "状态",
    dataIndex: "status_text",
    ellipsis: true,
    key: "status_text",
    scopedSlots: { customRender: "status" },
    width: "100px"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: "100px"
  }
];
export default {
  name: "index",
  data() {
    return {
      data: [],
      columns,
      loading: false
    };
  },
  props: {
    seachData: {
      type: Object,
      default: () => {}
    }
  },
  components: { ProductImportModal },
  computed: {},
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      API.service
        .GET_DETAIL_RECORD({
          a_customer_id: this.seachData.id
        })
        .then((res) => {
          this.data = res.data.data;
          this.loading = false;
        });
    },
    delLog(id) {
      API.service.DETAIL_DELE({ id }).then((res) => {
        this.getList();
      });
    },
    importProduct() {
      this.$refs.proImportModal.visible = true;
    }
  }
};
</script>
<style scoped>
h1 {
  font-size: 16px;
  font-weight: bold;
}
.red {
  color: #f56c6c;
}
</style>
